<div *ngIf='comments' class='VsmCommentsListing p-5'>
  <div class='VsmCommentsListing-header d-flex flex-row mb-5'>
    <div
      class='VsmCommentsListing-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1 d-flex flex-row'>
        <div class='flex-grow-1 d-flex flex-row'>
          <div class='Breadcrumbs'>
            <div class='Breadcrumbs-items'>
              <a [routerLink]="['/contents']"
              >
                <mat-icon class='Breadcrumbs-icon back'
                >keyboard_backspace
                </mat-icon
                >
              </a
              >
              <a [routerLink]="['/contents']" class='Breadcrumbs-item'
              >Edge Comments</a
              >
            </div>
          </div>
        </div>
        <div class='flex-grow-0 text-end'>
          <app-button
            [Click]='newButtonProperties.onClick'
            [color]='newButtonProperties.color'
            [size]='newButtonProperties.size'
            [text]='newButtonProperties.text'
            class='pull-right'></app-button>
        </div>
      </div>
    </div>
  </div>
  <div class='VsmCommentsListing-items'>
    <div
      *ngFor='let response of comments'
      class='VsmCommentsListing-items-item d-flex flex-row'>
      <div class='flex-grow-1 d-flex align-items-center'>
        <h4>{{ response.name }}</h4>
      </div>
      <div class='flex-grow-0'>
        <app-button
          *ngIf='response.editable'
          [Click]='
            editButtonProperties.onClick.bind(this, response)
          '
          [color]='editButtonProperties.color'
          [size]='editButtonProperties.size'
          [style]="'filled'"
          [text]='editButtonProperties.text'></app-button>
        <app-button
          *ngIf='response.editable'
          [Click]='
            deleteButtonProperties.onClick.bind(this, response)
          '
          [color]='deleteButtonProperties.color'
          [size]='deleteButtonProperties.size'
          [style]="'filled'"
          [text]='deleteButtonProperties.text'
          class='ms-1'></app-button>
      </div>
    </div>
  </div>
</div>
